import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Card } from "@themesberg/react-bootstrap";

const TONE_STYLES = {
  primary: { color: "#2563EB", accent: "rgba(37, 99, 235, 0.1)" },
  success: { color: "#16A34A", accent: "rgba(22, 163, 74, 0.1)" },
  warning: { color: "#F59E0B", accent: "rgba(245, 158, 11, 0.12)" },
  danger: { color: "#DC2626", accent: "rgba(220, 38, 38, 0.1)" },
  info: { color: "#0EA5E9", accent: "rgba(14, 165, 233, 0.12)" },
  dark: { color: "#111827", accent: "rgba(17, 24, 39, 0.08)" },
};

export default function DashboardStatCard({
  title,
  subtitle,
  value,
  icon,
  loading = false,
  tone = "primary",
  footer,
  onClick,
  className = "",
}) {
  const toneStyle = TONE_STYLES[tone] || TONE_STYLES.primary;
  const clickable = typeof onClick === "function";

  return (
    <Card
      className={`dashboard-stat-card border-0 h-100 ${clickable ? "dashboard-stat-card-clickable" : ""} ${className}`}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-start gap-3">
          <div className="flex-grow-1 min-w-0">
            <div className="dashboard-stat-title">{title}</div>
            {subtitle && <div className="dashboard-stat-subtitle">{subtitle}</div>}
          </div>
          {icon && (
            <div
              className="dashboard-stat-icon rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ background: toneStyle.accent, color: toneStyle.color }}
            >
              <FontAwesomeIcon icon={icon} />
            </div>
          )}
        </div>
        <div className="dashboard-stat-value mt-3">
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : value}
        </div>
        {footer && <div className="dashboard-stat-footer mt-2">{footer}</div>}
      </Card.Body>
    </Card>
  );
}
